<!-- 插件料 -->
<template>
  <BaseFormItem
    class="is_plug"
    :label="fields.label"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <!-- 焊接插件料 -->
    <BaseRadioGroup v-model="val.is_plug" @change="() => handleEmit('is_plug')">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >
        {{ item.label }}
      </el-radio-button>
    </BaseRadioGroup>
    <template v-if="val.is_plug == 1">
      <BaseCheckbox 
        class="is_plug__checkbox"
        v-model="val.is_assembly_weld_for_tin"
        :true-label="1"
        :false-label="0"
        @change="() => handleEmit('is_assembly_weld_for_tin')"
      >
        不焊接物料的插件孔可以上锡
      </BaseCheckbox>
      <BaseTipPopover width="340px" content="我司的常规操作：不焊接物料的插件孔全部不上锡" />
    </template>
  </BaseFormItem>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    // 焊接插件料
    is_plug: {
      type: Number,
      default: 1
    },
    // 不焊接物料的插件孔可以上锡
    is_assembly_weld_for_tin: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      val: {
        is_plug: this.is_plug,
        is_assembly_weld_for_tin: this.is_assembly_weld_for_tin
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('is_plug')
    }
  },
  watch: {
    is_plug(newVal) {
      this.val.is_plug = newVal
    },
    is_assembly_weld_for_tin(newVal) {
      this.val.is_assembly_weld_for_tin = newVal
    },
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.is_plug {
  .is_plug__checkbox {
    margin: 0 10px;
  }
}
</style>